import React from "react";
import {Icon} from "@iconify/react";

const FeatureBlock = (props) => {

    let classes = 'featureBlock d-flex align-items-center';
    let classesText = 'featureBlock__text d-inline-block';
    let justifyContent = " justify-content-start";

    if (props.price) {
        justifyContent = " justify-content-between";
        classesText += " font-weight-bold";
    }

    classes += justifyContent;

    return (
        <div className={classes}>

            {props.icon &&
            <div className="featureBlock__icon d-inline-block d-flex align-items-center">
                <Icon icon={props.icon} className="color-sea"/>
            </div>
            }

            <div className={classesText}>
                {props.text}
            </div>

            {props.price  &&
                <div className="featureBlock__text d-inline-block text-right">
                    {props.price}
                </div>
            }
        </div>
    )
};

export default FeatureBlock;
